import React, { useEffect, useState } from "react"
import XPMotorApi from '@xpeng/xpmotors-jsbridge-api'
import { disableShareOpt, closeWebview } from '@/utils/common'
import styles from './index.module.scss'
import MessageBox from "@/components/message-box"
import useQuery from "@/hooks/useQuery"
import { isSupportLocationDisplay } from "../config"

import {
  // getEnableRecordStatus,
  postSwitchEnableRecord,
  getSettingsQuery
} from '@/api/trips-report'

const DEFAULT_ERROR_MSG = '服务器开小差啦'

const App = () => {
  // 判断是否支持位置展示
  const isSupportLocation = isSupportLocationDisplay()
  const queryVin = useQuery().get('vin') || ''
  const [isOpen, setIsOpen] = useState(true)
  const [addressDisplay, setAddressDisplay] = useState(true)
  useEffect(() => {
    document.title = '行程记录设置'
    // 设置页需要手动隐藏自定义导航栏图标，否则图标会带到这里
    disableShareOpt()
    // getEnableStatus()
    getSettingStatus()
  }, [])

const getSettingStatus = () => {
  getSettingsQuery({ vin: queryVin })
    .then((res: any) => {
      if (res.code === 200) {
        setIsOpen(!!res?.data?.moduleEnabled)
        setAddressDisplay(!!res?.data?.displayAddress)
      }
    })
  .catch(err => {})
}

  // const getEnableStatus = () => {
  //   getEnableRecordStatus({ vin: queryVin }).then(res => {
  //     if (res.code === 200) {
  //       setIsOpen(!!res.data)
  //     }
  //   }).catch(err => {})
  // }

  const switchEnableRecord = () => {
    MessageBox.confirm({
      title: isOpen ? '是否关闭行程记录' : '行程记录功能开启',
      message: isOpen ? '关闭后，行程数据将被清空并不再记录' : '开启后从当天开始记录里程、时长、位置等信息',
      cancelButtonText: isOpen ? '取消' : '暂不开启',
      confirmButtonText: isOpen ? '确认' : '确认开启'
    }).then(() => {
      postSwitchEnableRecord(
        { moduleEnabled: !isOpen, displayAddress: addressDisplay },
        queryVin
      )
        .then(res => {
          if (res.code === 200) {
            // 当前是开启状态，点击关闭以后关闭浏览器，回到车控页
            // 当前是关闭状态，点击开启以后，只切换开关样式
            if (isOpen) {
              XPMotorApi.setResult({ result: 'closeWindow' })
              closeWebview()
            } else {
              XPMotorApi.setResult({ result: 'reload' })
            }
            setIsOpen(isOpen => !isOpen)
          } else {
            MessageBox.toast(DEFAULT_ERROR_MSG)
          }
        }).catch(err => {
          MessageBox.toast(DEFAULT_ERROR_MSG)
        })
    }).catch(() => {})
  }

  const switchLocationDisplay = () => {
    postSwitchEnableRecord(
      { moduleEnabled: isOpen, displayAddress: !addressDisplay },
      queryVin
    )
      .then(res => {
        if (res.code === 200) {
          setAddressDisplay(addressDisplay => !addressDisplay)
        } else {
          MessageBox.toast(DEFAULT_ERROR_MSG)
        }
      }).catch(err => {
        MessageBox.toast(DEFAULT_ERROR_MSG)
      })
  }

  return (
    <div className={styles.homePage}>
      <div className={styles.btnBar}>
        <div className={styles.info}>
          <div className={styles.title}>开启行程记录</div>
          <div className={styles.tips}>关闭后，行程数据将被清空并不再记录</div>
        </div>
        <div className={`${styles.btnBlock} ${isOpen ? '' : styles.close}`} onClick={switchEnableRecord}>
          <div className={`${styles.switch}`}></div>
        </div>
      </div>
      { isSupportLocation && (
        <div className={`${styles.btnBar} ${styles.mt12}`}>
          <div className={styles.info}>
            <div className={styles.title}>出发地目的地显示</div>
            <div className={styles.tips}>开启后将会展示每段行程的出发地和目的地</div>
          </div>
          <div className={`${styles.btnBlock} ${addressDisplay ? '' : styles.close}`} onClick={switchLocationDisplay}>
            <div className={`${styles.switch}`}></div>
          </div>
        </div>
      )}
    </div>
  )
}

export default App